(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.gm-reveal');
    if (!els.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('gm-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-gm-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('gm-visible');
            }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll('[data-gm-marquee]').forEach(function (track) {
      if (track.dataset.gmDuplicated) return;
      track.dataset.gmDuplicated = 'true';
      var content = track.innerHTML;
      track.innerHTML = content + content;
      var speed = Number(track.getAttribute('data-gm-speed')) || 32;
      track.style.animationDuration = speed + 's';
    });
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-gm-count-to]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = Number(el.getAttribute('data-gm-count-to')) || 0;
          var suffix = el.getAttribute('data-gm-count-suffix') || '';
          var duration = 1400;
          var start = performance.now();

          function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          observer.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (el) { observer.observe(el); });
  }

  function initAccordion() {
    document.querySelectorAll('[data-gm-accordion]').forEach(function (item) {
      var trigger = item.querySelector('[data-gm-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('gm-open');
        item.closest('[data-gm-accordion-group]')
          .querySelectorAll('[data-gm-accordion]')
          .forEach(function (i) { i.classList.remove('gm-open'); });
        if (!isOpen) item.classList.add('gm-open');
      });
    });
  }

  function initTiltCards() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('[data-gm-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMarquee();
    initCounters();
    initAccordion();
    initTiltCards();
  });
})();
